// stores/useDateRangeStorePageA.ts
import { useDateRangeStore } from "@/stores/useDateRangeStore";

// eslint-disable-next-line react-hooks/rules-of-hooks
export const useDateRangeStoreSiteSketch = useDateRangeStore("siteSketch");

// eslint-disable-next-line react-hooks/rules-of-hooks
export const useDateRangeStoreMajor = useDateRangeStore("major");

// eslint-disable-next-line react-hooks/rules-of-hooks
export const useDateRangeStoreJobList = useDateRangeStore("jobList");
